import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

// Aug 2026 UX pass — items 5 & 13: a slim, per-role metrics strip for the
// top of "My Day". Deliberately NOT a KPI dashboard — every number is a
// real backend-derived count and every tile is clickable, navigating
// straight to the filtered list/action behind it. No number is decorative.
//
// items: [{ key, label, value, onClick, tone }]
//   tone: "default" | "warn" | "danger" — accent color for the number.
export function MyDayMetricsStrip({ items, className }) {
  const navigate = useNavigate();
  if (!items?.length) return null;
  return (
    <div className={cn("grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5 px-4 pt-5 md:px-6", className)} data-testid="myday-metrics-strip">
      {items.map((item) => {
        const clickable = typeof item.onClick === "function";
        const tone = item.tone === "danger" ? "text-red-600" : item.tone === "warn" ? "text-amber-600" : "text-slate-900";
        const Comp = clickable ? "button" : "div";
        return (
          <Comp
            key={item.key || item.label}
            data-testid={`myday-metric-${item.key || item.label}`}
            onClick={clickable ? () => item.onClick(navigate) : undefined}
            className={`rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-left transition-colors ${clickable ? "hover:border-indigo-300 hover:bg-indigo-50/40 cursor-pointer" : ""}`}
          >
            <div className="text-[10.5px] font-semibold uppercase tracking-wider text-slate-400">{item.label}</div>
            <div className={`mt-1 font-display text-xl font-bold font-mono-num ${tone}`}>{item.value}</div>
          </Comp>
        );
      })}
    </div>
  );
}
